import { assertDefined } from '@/utils/assertDefined';
import { FRAGMENT_SHADER_SOURCE } from './webgl-image-filters/lib/fragment-shader-source';

let isFilterSupported: boolean | undefined;
export function getIsFilterSupported() {
  if (typeof isFilterSupported === 'boolean') {
    return isFilterSupported;
  }

  try {
    const canvas = document.createElement('canvas');
    const gl =
      canvas.getContext('webgl') ||
      (canvas.getContext('experimental-webgl') as WebGLRenderingContext);
    if (gl) {
      // high float precision which is necessary for the filters
      //  is not available on all devices (mostly older androids)
      const shader = assertDefined(gl.createShader(gl.FRAGMENT_SHADER));
      gl.shaderSource(shader, FRAGMENT_SHADER_SOURCE);
      gl.compileShader(shader);

      if (gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        return (isFilterSupported = true);
      }
    }
  } catch (e) {
    // any error means that filter will not work
  }

  return (isFilterSupported = false);
}
